import styled from '@emotion/styled';
import { default as ListingCard } from '../ListingCard';
import { css } from '@emotion/react';

export const ListingsContainer = styled('div')(
    ({ theme }) => css`
        margin-bottom: ${theme.spacing['24px']};
        > * + * {
            margin-top: ${theme.spacing['32px']};
        }
    `
);

export const StyledListingCard = styled(ListingCard)(
    () => css`
        margin-left: auto;
        margin-right: auto;
        width: 100%;
        contain: content;
    `
);

export const ResetButtonContainer = styled('div')(
    ({ theme }) => css`
        margin-top: ${theme.spacing['24px']};
    `
);
